import Splide from '@splidejs/splide';

const ELS = document.querySelectorAll('.js-videos-carousel');

ELS.forEach((EL) => {
  new Splide( EL, {
    arrows: true,
    pagination: false,
    fixedWidth: '240px',
    gap: 16,
    omitEnd: true,
    breakpoints: {
      768: {
        fixedWidth: '180px',
        gap: 10,
      },
    }
  } ).mount();
});
